import React, { ReactNode } from 'react';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { twMerge } from 'tailwind-merge';
import { ReactComponent as CheckIcon } from '../../../../../assets/icons/svg/colored-icons/ic-colored-selected.svg';
import { ReactComponent as UncheckIcon } from '../../../../../assets/icons/svg/colored-icons/ic-colored-unselected.svg';
import { ReactComponent as InfoIcon } from '../../../../../assets/icons/svg/shared/ic-shared-question-mark.svg';
import { RoleType } from '../../../../../types';

export interface InviteOptionItemProps {
  title: string;
  type: RoleType;
  description: string;
  disabled: boolean;
  hidden: boolean;
  icon: ReactNode;
  isSelected: boolean;
  onSelect: (role: RoleType) => void;
  onInfoClick: (role: RoleType) => void;
}

export const InviteOptionItem = ({
  title,
  description,
  icon,
  isSelected,
  onSelect,
  disabled,
  onInfoClick,
  type,
  hidden,
}: InviteOptionItemProps) => (
  <button
    type='button'
    id={`invite-option-${type}`}
    onClick={() => !disabled && onSelect(type)}
    className={twMerge(
      'cursor-pointer w-full flex flex-row items-center bg-bw01 px-[14px] py-[12px]  border-[1px] rounded-md justify-between hover:border-action03 border-bw04',
      disabled && 'border-0 cursor-default',
      hidden && 'hidden',
    )}
    data-tooltip-id={`invite-disabled-tooltip-${type}`}
  >
    <div className='flex flex-row items-center '>
      {icon}
      <div className='flex flex-col pl-[8px]'>
        <div className='flex flex-row items-center gap-1'>
          <Heading.H9
            fontWeight={FontWeight.MEDIUM}
            className={twMerge(disabled ? 'text-text-main-tertiary' : 'text-text-main-primary')}
          >
            {title}
          </Heading.H9>
          <InfoIcon
            className='text-text-brand-primary hover:text-text-main-tertiary cursor-pointer'
            onClick={() => onInfoClick(type)}
          />
        </div>
        <Heading.H10 className={twMerge(disabled ? 'text-text-main-tertiary' : 'text-text-main-secondary')}>
          {description}
        </Heading.H10>
      </div>
    </div>
    {!disabled && (
      <div>
        {isSelected ? <CheckIcon className='w-[20px] h-[20px]' /> : <UncheckIcon className='w-[20px] h-[20px]' />}
      </div>
    )}
  </button>
);
